import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@breath-lab/state';
import { ROUTES } from '@app/routes';

interface Props {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return null;

  if (!isAuthenticated) {
    return (
      <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />
    );
  }

  return <>{children}</>;
}
